import {
    FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_FAILURE_DK,
    NAVIGATE_REPORT_STOCK_LEDGER_DETAIL_DK,
    FETCH_STOCK_WISE_LEDGER_DETAIL_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_STOCK_WISE_LEDGER_DETAIL_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_STOCK_WISE_LEDGER_DETAIL_DATA_FOR_REPORT_FAILURE_DK,
    FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_FAB_REQUEST_DK,
    FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_FAB_SUCCESS_DK,
    FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_FAB_FAILURE_DK,
    FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_ACC_REQUEST_DK,
    FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_ACC_SUCCESS_DK,
    FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_ACC_FAILURE_DK,
    NAVIGATE_REPORT_STOCK_FAB_LEDGER_DETAIL_DK,
    NAVIGATE_REPORT_STOCK_LEDGER_RESET_DK,
    NAVIGATE_REPORT_STOCK_LEDGER_DK,
    NAVIGATE_REPORT_STOCK_FAB_LEDGER_RESET_DK,
    NAVIGATE_REPORT_STOCK_FAB_LEDGER_DK
    //NAVIGATE_REPORT_STOCK_LEDGER_BACK_DK
} from './stockWiseReportsLedger.actionType';

export const REPORT_STOCK_LEDGER_DK = 'reportStockLedgerDK';

let initialState = {
    loading: false,
    reportProgramStockWiseLedgerList: [],
    reportProgramStockWiseLedgerFABList: [],
    reportProgramStockWiseLedgerACCList: [],
    stockreportLedgerFabricDetailSelectedValue: {},
    isStockReportLedgerFabricDetail: false,
    stockreportLedgerDetailSelectedValue: {},
    isStockReportLedgerDetail: false
    //isStockReportLedgerDetailBack: false
};

export let reportStockLedgerDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_REQUEST_DK:
        case FETCH_STOCK_WISE_LEDGER_DETAIL_DATA_FOR_REPORT_REQUEST_DK:
        case FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_FAB_REQUEST_DK:
        case FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_ACC_REQUEST_DK:
            return {
                ...state,
                loading: true
            };

        case FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_SUCCESS_DK:
        case FETCH_STOCK_WISE_LEDGER_DETAIL_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportProgramStockWiseLedgerList: updatePayload
            };
        case FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_ACC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportProgramStockWiseLedgerACCList: updatePayload
            };
        case FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_FAB_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportProgramStockWiseLedgerFABList: updatePayload
            };
        case FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_FAILURE_DK:
        case FETCH_STOCK_WISE_LEDGER_DETAIL_DATA_FOR_REPORT_FAILURE_DK:
        case FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_FAB_FAILURE_DK:
        case FETCH_STOCK_WISE_LEDGER_DATA_FOR_REPORT_ACC_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_REPORT_STOCK_LEDGER_DETAIL_DK:
            return {
                ...state,
                isStockReportLedgerDetail: true,
                stockreportLedgerDetailSelectedValue: updatePayload?.stockreportLedgerDetailSelectedValue
            };
        case NAVIGATE_REPORT_STOCK_FAB_LEDGER_DETAIL_DK:
            return {
                ...state,
                isStockReportLedgerFabricDetail: true,
                stockreportLedgerFabricDetailSelectedValue: updatePayload?.stockreportLedgerFabricDetailSelectedValue
            };
        case NAVIGATE_REPORT_STOCK_LEDGER_RESET_DK:
            return {
                ...state,
                loading: false,
                isStockReportLedgerDetail: false
            };
        case NAVIGATE_REPORT_STOCK_FAB_LEDGER_RESET_DK:
            return {
                ...state,
                loading: false,
                isStockReportLedgerFabricDetail: false
            };
        case NAVIGATE_REPORT_STOCK_LEDGER_DK:
            return {
                ...state,
                isStockReportLedgerDetail: false
            };
        case NAVIGATE_REPORT_STOCK_FAB_LEDGER_DK:
            return {
                ...state,
                isStockReportLedgerFabricDetail: false
            };
            {
                /*case NAVIGATE_REPORT_STOCK_LEDGER_BACK_DK:
            return {
                ...state,

                isStockReportLedgerDetailBack: true
            };*/
            }
        default:
            return state;
    }
};
